import { InputTag } from 'mixs/base/input_mixin';
import { PLANNER_CHANGE_UNDER } from 'apps/events';
export class RadioUnder extends InputTag {
  public init() {
    super.init();
    this.watch();
  }
  public onChange(e){
    let customEvent = new CustomEvent(PLANNER_CHANGE_UNDER);
    document.dispatchEvent(customEvent);
    // let scope = "phase_" + e.target.value
    // let newValue = {};
    // newValue[scope] = e.target.checked;
    // this.dispatchNewValue({
    //   forms_orders_save: newValue
    // })
  }
}

riot.mixin('inputs.complex.radio-under', RadioUnder as riot.TagMixin)
